import React, {useEffect} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {RatingsBody} from './RatingsBody';
import {showModal} from '../../actions/general';
import MDSpinner from 'react-md-spinner';
import {getAppsWithRatings} from '../../actions/ratings';
import {removeAppFromGroup} from '../../actions/apps';
import {UpdateTimeHeader} from '../general/UpdateTimeHeader';

const Ranks = ({
  getAppsWithRatings, isLoadApps, isLoadingApps, deleteApp, groups,
  apps, countries, showModal, maxRatingsByCountries, lastUpdateAppsDate,
}) => {
  useEffect(() => {
    if (isLoadApps && !isLoadingApps) {
      getAppsWithRatings();
    }
  }, [isLoadApps]);

  const rendersRanks = () => {
    return Object.keys(apps).sort((a, b) => {
      a = groups[Number(a)].order;
      b = groups[Number(b)].order;
      if (a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
      return 0;
    }).map((groupId) => {
      return <RatingsBody
        key={groupId + '_appGroup'}
        isLoadingApps={isLoadingApps}
        apps={apps[groupId]}
        group={groups[Number(groupId)]}
        isNewGroup={false}
        maxRatingsByCountries={maxRatingsByCountries[groupId]}
        countries={countries}
        showModal={showModal}
        deleteApp={deleteApp}
        totalGroups={Object.keys(groups).length}
      />;
    });
  };

  if (isLoadingApps) {
    return (
      <div className='spinner-container' style={{width: '100%'}}>
        <MDSpinner size={100} singleColor={'#00DADA'}/>
      </div>
    );
  }

  return (
    <div className={'ranks-container'}>
      <UpdateTimeHeader
        date={lastUpdateAppsDate}
      />
      {rendersRanks()}
      <RatingsBody
        isLoadingApps={isLoadingApps}
        apps={[]}
        isNewGroup={true}
        group={null}
        maxRanksByCountries={{}}
        countries={countries}
        showModal={showModal}
        totalGroups={Object.keys(groups).length}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoadApps: state.ratings.isLoadApps,
  isLoadingApps: state.ratings.isLoadingApps,
  apps: state.ratings.apps,
  countries: state.ratings.countries,
  maxRatingsByCountries: state.ratings.maxRatingsByCountries,
  lastUpdateAppsDate: state.ratings.lastUpdateAppsDate,
  groups: state.ratings.groups,
});

const mapDispatchToProps = (dispatch) => ({
  getAppsWithRatings: bindActionCreators(getAppsWithRatings, dispatch),
  showModal: bindActionCreators(showModal, dispatch),
  deleteApp: bindActionCreators(removeAppFromGroup, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Ranks);
